import clsx from "clsx";

export interface DescriptionProps {
  description: string;
  background_color?: string;
}

export default function Description(props: DescriptionProps) {
  return (
    <div
      style={
        props.background_color
          ? { backgroundColor: props.background_color }
          : {}
      }
      className={clsx(
        "py-16 xl:py-36 leading-loose text-center text-white relative",
        {
          "bg-darkgold": !props.background_color,
        }
      )}
    >
      <img
        src="/homepage/stempel.svg"
        alt="logo"
        className="absolute -top-4/12 -left-1/12 hidden xl:block"
      />

      <div className="w-full px-14 xl:px-0 xl:max-w-screen-xl mx-auto">
        <h2
          className="text-sm xl:text-3xl xl:leading-12 z-10 relative "
          dangerouslySetInnerHTML={{ __html: props.description }}
        ></h2>
      </div>
    </div>
  );
}
